import React from 'react';
// import { valentine_discount } from 'app.config';
// import { useDispatch } from 'react-redux';

import styled from 'styled-components';
// import { useSearchParams } from 'react-router-dom';

const SalesBanner = ({ label, showLink }) => {
  // const dispatch = useDispatch();

  // const [, setParams] = useSearchParams();

  // const handleClick = () => {
  //   if (showLink) {
  //     setParams({ discount_code: valentine_discount });
  //     dispatch.subscription.setCouponCode(valentine_discount);
  //     dispatch.utils.setSubscriptionModal(true);
  //     dispatch.subscription.setPlanId('');
  //   }
  // };

  return (
    <Container>
      <p className='font-size-18'>
        {label}
        {showLink && (
          <span>
            {' '}
            -{' '}
            <span
              className='n'
              role='button'
              style={{ font: 'inherit', fontWeight: 'bold' }}
            >
              Upgrade Now
            </span>
          </span>
        )}
      </p>
    </Container>
  );
};

export default SalesBanner;

const Container = styled.div`
  width: 100%;
  padding: 10px 20px;
  background-color: ${({ theme }) => theme.colors.red};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;

  & p {
    margin: 0px;
    font-weight: 400;
  }
  & .n {
    text-decoration: underline;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.primary};
  }
`;
